module.exports = __webpack_public_path__ + "media/24.dbef7595.mp3";